/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminPermissionSet { 
    /**
     * Time at which the object was created.
     */
    created_at: string;
    /**
     * Time at which the object was deleted.
     */
    deleted_at?: string;
    /**
     * Is this permission set allowed to be used
     */
    enabled: boolean;
    /**
     * Unique identifier for the object.
     */
    id: string;
    /**
     * The id of the last admin user to update this permission set.
     */
    last_updated_by: string;
    /**
     * User-friendly name (e.g. \'Read-only default\')
     */
    name: string;
    /**
     * The list of permissions for this set.
     */
    permissions: Array<AdminPermissionSet.PermissionsEnum>;
    /**
     * Time at which the object was last updated.
     */
    updated_at: string;
}
export namespace AdminPermissionSet {
    export type PermissionsEnum = '*' | 'feature_toggles:read' | 'feature_toggles:write' | 'business_profile.tax_id:read' | 'business_profile.tax_id:write' | 'user_invitations:read' | 'user_invitations:write' | 'product_codes:write' | 'pricing_templates:write' | 'partner_revenue_share_schedules:write' | 'partner_revenue_share_schedules:verify' | 'buy_rates:write' | 'buy_rates:verify' | 'fee_schedules:write' | 'paysafe_secrets:read' | 'paysafe_secrets:write' | 'auth0_tenants:write' | 'handpoint_secrets:read' | 'handpoint_secrets:write' | 'valor_secrets:read' | 'valor_secrets:write' | 'users:read' | 'users:write' | 'admin_permission_sets:read' | 'admin_permission_sets:write' | 'admin_user_groups:read' | 'admin_user_groups:write' | 'request_logs:read' | 'files.onboarding_documentation:read' | 'files.onboarding_documentation:write' | 'onboarding:read' | 'onboarding:write' | 'subscriptions:cancel' | 'underwriting:read' | 'underwriting:write' | 'payment_methods:export' | 'terminal_readers:read' | 'terminal_readers:write' | 'statement:read' | 'statement:write' | 'disputes:write';
    export const PermissionsEnum = {
        STAR: '*' as PermissionsEnum,
        FEATURE_TOGGLES_READ: 'feature_toggles:read' as PermissionsEnum,
        FEATURE_TOGGLES_WRITE: 'feature_toggles:write' as PermissionsEnum,
        BUSINESS_PROFILE_TAX_ID_READ: 'business_profile.tax_id:read' as PermissionsEnum,
        BUSINESS_PROFILE_TAX_ID_WRITE: 'business_profile.tax_id:write' as PermissionsEnum,
        USER_INVITATIONS_READ: 'user_invitations:read' as PermissionsEnum,
        USER_INVITATIONS_WRITE: 'user_invitations:write' as PermissionsEnum,
        PRODUCT_CODES_WRITE: 'product_codes:write' as PermissionsEnum,
        PRICING_TEMPLATES_WRITE: 'pricing_templates:write' as PermissionsEnum,
        PARTNER_REVENUE_SHARE_SCHEDULES_WRITE: 'partner_revenue_share_schedules:write' as PermissionsEnum,
        PARTNER_REVENUE_SHARE_SCHEDULES_VERIFY: 'partner_revenue_share_schedules:verify' as PermissionsEnum,
        BUY_RATES_WRITE: 'buy_rates:write' as PermissionsEnum,
        BUY_RATES_VERIFY: 'buy_rates:verify' as PermissionsEnum,
        FEE_SCHEDULES_WRITE: 'fee_schedules:write' as PermissionsEnum,
        PAYSAFE_SECRETS_READ: 'paysafe_secrets:read' as PermissionsEnum,
        PAYSAFE_SECRETS_WRITE: 'paysafe_secrets:write' as PermissionsEnum,
        AUTH0_TENANTS_WRITE: 'auth0_tenants:write' as PermissionsEnum,
        HANDPOINT_SECRETS_READ: 'handpoint_secrets:read' as PermissionsEnum,
        HANDPOINT_SECRETS_WRITE: 'handpoint_secrets:write' as PermissionsEnum,
        VALOR_SECRETS_READ: 'valor_secrets:read' as PermissionsEnum,
        VALOR_SECRETS_WRITE: 'valor_secrets:write' as PermissionsEnum,
        USERS_READ: 'users:read' as PermissionsEnum,
        USERS_WRITE: 'users:write' as PermissionsEnum,
        ADMIN_PERMISSION_SETS_READ: 'admin_permission_sets:read' as PermissionsEnum,
        ADMIN_PERMISSION_SETS_WRITE: 'admin_permission_sets:write' as PermissionsEnum,
        ADMIN_USER_GROUPS_READ: 'admin_user_groups:read' as PermissionsEnum,
        ADMIN_USER_GROUPS_WRITE: 'admin_user_groups:write' as PermissionsEnum,
        REQUEST_LOGS_READ: 'request_logs:read' as PermissionsEnum,
        FILES_ONBOARDING_DOCUMENTATION_READ: 'files.onboarding_documentation:read' as PermissionsEnum,
        FILES_ONBOARDING_DOCUMENTATION_WRITE: 'files.onboarding_documentation:write' as PermissionsEnum,
        ONBOARDING_READ: 'onboarding:read' as PermissionsEnum,
        ONBOARDING_WRITE: 'onboarding:write' as PermissionsEnum,
        SUBSCRIPTIONS_CANCEL: 'subscriptions:cancel' as PermissionsEnum,
        UNDERWRITING_READ: 'underwriting:read' as PermissionsEnum,
        UNDERWRITING_WRITE: 'underwriting:write' as PermissionsEnum,
        PAYMENT_METHODS_EXPORT: 'payment_methods:export' as PermissionsEnum,
        TERMINAL_READERS_READ: 'terminal_readers:read' as PermissionsEnum,
        TERMINAL_READERS_WRITE: 'terminal_readers:write' as PermissionsEnum,
        STATEMENT_READ: 'statement:read' as PermissionsEnum,
        STATEMENT_WRITE: 'statement:write' as PermissionsEnum,
        DISPUTES_WRITE: 'disputes:write' as PermissionsEnum
    };
}


